import { getDateString } from './date-utils';

export function adaptAllMatchesFromWebsocket(stateDataObject, gamesFromWebsocket) {
    let newStateData = { ...stateDataObject };

    gamesFromWebsocket.forEach(each => {
        const gameDateAndIndex = findGameDateAndIndex(newStateData, each.match_id.toString());
        if (gameDateAndIndex.index !== -1) {
            //only try to adapt information received of this game, if the index was found on stateDataObject
            switch (each.type) {
                case "soccer.match":
                    // each.data format on type="soccer.match":
                    // "data": {
                    //     "ow_match_id": 694576,
                    //     "date_utc": "2014-01-03",
                    //     "time_utc": "08:30:00",
                    //     "team_A_id": 143,
                    //     "ow_team_A_id": 2309,
                    //     "team_A_name": "Adelaide United",
                    //     "team_A_country": "AUS",
                    //     "team_B_id": 4295,
                    //     "ow_team_B_id": 1962,
                    //     "team_B_name": "Sydney",
                    //     "team_B_country": "AUS",
                    //     "status": "Played",
                    //     "gameweek": 13,
                    //     "winner": "draw",
                    //     "fs_A": 2,
                    //     "fs_B": 2,
                    //     "hts_A": 1,
                    //     "hts_B": 1,
                    //     "match_period": "FT",
                    //     "lineup": true
                    // }
                    const adaptedGame = adaptMatchOnGame(newStateData[gameDateAndIndex.date][gameDateAndIndex.index], each.data);
                    newStateData[gameDateAndIndex.date][gameDateAndIndex.index] = adaptedGame;

                    break;
                case "soccer.events":
                    // each.data format on type="soccer.events":
                    // "data": {
                    //     "13867552": {
                    //         "event_id": 13867552,
                    //         "code": "L",
                    //         "name": "Line-up",
                    //         "person": "E. Galeković",
                    //         "person_id": 17527,
                    //         "ow_person_id": "",
                    //         "team_id": 143,
                    //         "ow_team_id": 2309,
                    //         "minute": 0,
                    //         "minute_extra": "",
                    //         "shirtnumber": 1,
                    //         "last_updated": "2014-01-03 08:57:49"
                    //     },
                    //     "13867553": {
                    //         "event_id": 13867553,
                    //         "code": "SUB",
                    //         "name": "Substitution on bench",
                    //         "person": "N. Boogaard",
                    //         "person_id": 17523,
                    //         "ow_person_id": "",
                    //         "team_id": 143,
                    //         "ow_team_id": 2309,
                    //         "minute": 0,
                    //         "minute_extra": "",
                    //         "shirtnumber": 3,
                    //         "last_updated": "2014-01-03 08:57:49"
                    //     },
                    //     "13867554": {
                    //         "event_id": 13867554,
                    //         "code": "L",
                    //         "name": "Line-up",
                    //         "person": "J. McKain",
                    //         "person_id": 12278,
                    //         "ow_person_id": "",
                    //         "team_id": 143,
                    //         "ow_team_id": 2309,
                    //         "minute": 0,
                    //         "minute_extra": "",
                    //         "shirtnumber": 4,
                    //         "last_updated": "2014-01-03 08:57:49"
                    //     }
                    // }

                    // DO NOTHING HERE, this info is not used in the view AllMatchesPage
                    break;
                case "soccer.matchinfo":
                    // each.data format on type="soccer.matchinfo":
                    // "data": {
                    //     "venue": {
                    //         "venue_id": 21,
                    //         "name": "Coopers Stadium",
                    //         "city": "Adelaide",
                    //         "area_id": 19
                    //     },
                    //     "referee": {
                    //         "person_id": 63760,
                    //         "name": "S. Delovski",
                    //         "ow_person_id": ""
                    //     },
                    //     "assistant_referee": {
                    //         "person_id": 63765,
                    //         "name": "D. Goodwin",
                    //         "ow_person_id": ""
                    //     },
                    //     "fourth_official": {
                    //         "person_id": 326245,
                    //         "name": "C. Verdicchio",
                    //         "ow_person_id": ""
                    //     },
                    //     "attendance": {
                    //         "value": ""
                    //     },
                    //     "coach_team_a": {
                    //         "person": "Gombau",
                    //         "person_id": 233014,
                    //         "ow_person_id": ""
                    //     },
                    //     "coach_team_b": {
                    //         "person": "F. Farina",
                    //         "person_id": 122477,
                    //         "ow_person_id": ""
                    //     }
                    // } 

                    // DO NOTHING HERE, this info is not used in the view AllMatchesPage
                    break;
                default:
                // code block
            }
        }
    })

    return newStateData;
}

function findGameDateAndIndex(stateData, match_id_string) {
    const nowDateUtc = new Date(new Date().toISOString());
    const year = nowDateUtc.getFullYear();
    const month = nowDateUtc.getMonth();
    const day = nowDateUtc.getDate();
    const yesterday = new Date(year, month, day - 1);
    const tomorrow = new Date(year, month, day + 1);
    const todayString = getDateString(nowDateUtc);
    const yesterdayString = getDateString(yesterday);
    const tomorrowString = getDateString(tomorrow);

    let foundIndex = -1;
    let foundDate = "";

    stateData[todayString].forEach((each, index) => {
        if (each.match_id.toString() === match_id_string) {
            foundIndex = index;
            foundDate = todayString;
        }
    })

    // try yesterday if game not found yet
    if (foundIndex === -1) {
        stateData[yesterdayString].forEach((each, index) => {
            if (each.match_id.toString() === match_id_string) {
                foundIndex = index;
                foundDate = yesterdayString;
            }
        })
    }

    // try tomorrow if game not found yet
    if (foundIndex === -1) {
        stateData[tomorrowString].forEach((each, index) => {
            if (each.match_id.toString() === match_id_string) {
                foundIndex = index;
                foundDate = tomorrowString;
            }
        })
    }

    const result = {
        date: foundDate,
        index: foundIndex
    }
    return result;
}


// const objetoPertendido = {
//     aggr: 1,
//     area_id: 7,
//     area_name: "Europa",
//     bookmakers: [{}],
//     competition_id: 18,
//     competition_name: "UEFA Europa League",
//     date_utc: "2019-05-09",
//     ets_A: 1,
//     ets_B: 1,
//     events: [
//         {
//             code: "L",
//             event_group: 0,
//             event_id: 37048308,
//             last_updated: "2019-05-09 19:46:43",
//             minute: 0,
//             minute_extra: 0,
//             name: "Line-up",
//             person: "Kepa",
//             person_id: 200705,
//             person_position: "Goalkeeper",
//             person_position_x: "GK",
//             person_position_y: "C",
//             shirtnumber: 2,
//             team_id: 661,
//         },
//         {},
//     ],
//     form: [{
//         competition: 18,
//         form: [{
//             date_utc: "2019-05-29",
//             match_id: 2997898,
//             outcome: "W"
//         }, {},],
//         team: "a",
//         team_id: 661
//     }, {},],
//     fs_A: 1,
//     fs_B: 1,
//     gameweek: 0,
//     group_name: "",
//     head2head: [{
//         aggr: 1,
//         area_id: 7,
//         area_name: "Europa",
//         competition_id: 18,
//         competition_name: "UEFA Europa League",
//         date_utc: "2019-05-09",
//         ets_A: 1,
//         ets_B: 1,
//         fs_A: 1,
//         fs_B: 1,
//         gameweek: 0,
//         group_name: "",
//         match_id: 2997910,
//         minute: 0,
//         minute_extra: 0,
//         ps_A: 4,
//         ps_B: 3,
//         round_id: 48752,
//         round_name: "Semi-finals",
//         season_id: 16183,
//         season_name: "2018/2019",
//         status: "Played",
//         team_A_id: 661,
//         team_A_name: "Chelsea",
//         team_B_id: 979,
//         team_B_name: "Eintracht Frankfurt",
//         time_utc: "19:00:00",
//         winner: "team_A"
//     }, {}],
//     match_id: 2997910,
//     minute: 0,
//     minute_extra: 0,
//     ps_A: 4,
//     ps_B: 3,
//     round_id: 48752,
//     round_name: "Semi-finals",
//     season_id: 16183,
//     season_name: "2018/2019",
//     statistics: [{
//         name: "Posse de bola",
//         type: "possession",
//         value_team_A: 54,
//         value_team_B: 4
//     }],
//     status: "Played",
//     team_A_coach: [{
//         nationality_id: 100,
//         person_id: 168782,
//         person_name: "M. Sarri"
//     }],
//     team_A_formation: "4-3-3",
//     team_A_id: 661,
//     team_A_name: "Chelsea",
//     team_B_coach: [{ person_id: 178757, person_name: "A. Hütter", nationality_id: 20 }],
//     team_B_formation: "3-5-2",
//     team_B_id: 979,
//     team_B_name: "Eintracht Frankfurt",
//     time_utc: "20:00:00",
//     tips: [],
//     venue_area_name: "England",
//     venue_city: "London",
//     venue_id: 83,
//     venue_name: "Stamford Bridge",
//     winner: "team_A",
//     zapping: [],
// }

export function adaptMatchFromWebsocket(stateGameInfoObject, gameFromWebsocket) {

    const myMatchId = stateGameInfoObject.match_id.toString();
    let newGameInfoObject = { ...stateGameInfoObject };

    gameFromWebsocket.forEach(each => {
        if (myMatchId === each.match_id) {
            //only try to adapt information received of this game
            switch (each.type) {
                case "soccer.match":
                    // each.data format on type="soccer.match":
                    // "data": {
                    //     "ow_match_id": 694576,
                    //     "date_utc": "2014-01-03",
                    //     "time_utc": "08:30:00",
                    //     "team_A_id": 143,
                    //     "ow_team_A_id": 2309,
                    //     "team_A_name": "Adelaide United",
                    //     "team_A_country": "AUS",
                    //     "team_B_id": 4295,
                    //     "ow_team_B_id": 1962,
                    //     "team_B_name": "Sydney",
                    //     "team_B_country": "AUS",
                    //     "status": "Played",
                    //     "gameweek": 13,
                    //     "winner": "draw",
                    //     "fs_A": 2,
                    //     "fs_B": 2,
                    //     "hts_A": 1,
                    //     "hts_B": 1,
                    //     "match_period": "FT",
                    //     "lineup": true
                    // }
                    const adaptedGame = adaptMatchOnGame(newGameInfoObject, each.data);
                    newGameInfoObject = adaptedGame;

                    break;
                case "soccer.events":
                    // each.data format on type="soccer.events":
                    // "data": {
                    //     "13867552": {
                    //         "event_id": 13867552,
                    //         "code": "L",
                    //         "name": "Line-up",
                    //         "person": "E. Galeković",
                    //         "person_id": 17527,
                    //         "ow_person_id": "",
                    //         "team_id": 143,
                    //         "ow_team_id": 2309,
                    //         "minute": 0,
                    //         "minute_extra": "",
                    //         "shirtnumber": 1,
                    //         "last_updated": "2014-01-03 08:57:49"
                    //     },
                    //     "13867553": {
                    //         "event_id": 13867553,
                    //         "code": "SUB",
                    //         "name": "Substitution on bench",
                    //         "person": "N. Boogaard",
                    //         "person_id": 17523,
                    //         "ow_person_id": "",
                    //         "team_id": 143,
                    //         "ow_team_id": 2309,
                    //         "minute": 0,
                    //         "minute_extra": "",
                    //         "shirtnumber": 3,
                    //         "last_updated": "2014-01-03 08:57:49"
                    //     },
                    //     "13867554": {
                    //         "event_id": 13867554,
                    //         "code": "L",
                    //         "name": "Line-up",
                    //         "person": "J. McKain",
                    //         "person_id": 12278,
                    //         "ow_person_id": "",
                    //         "team_id": 143,
                    //         "ow_team_id": 2309,
                    //         "minute": 0,
                    //         "minute_extra": "",
                    //         "shirtnumber": 4,
                    //         "last_updated": "2014-01-03 08:57:49"
                    //     }
                    // }

                    const adaptedGameInfoEvents = adaptEventsOnGame(newGameInfoObject, each.data);
                    newGameInfoObject = adaptedGameInfoEvents;
                    break;
                case "soccer.matchinfo":
                    // each.data format on type="soccer.matchinfo":
                    // "data": {
                    //     "venue": {
                    //         "venue_id": 21,
                    //         "name": "Coopers Stadium",
                    //         "city": "Adelaide",
                    //         "area_id": 19
                    //     },
                    //     "referee": {
                    //         "person_id": 63760,
                    //         "name": "S. Delovski",
                    //         "ow_person_id": ""
                    //     },
                    //     "assistant_referee": {
                    //         "person_id": 63765,
                    //         "name": "D. Goodwin",
                    //         "ow_person_id": ""
                    //     },
                    //     "fourth_official": {
                    //         "person_id": 326245,
                    //         "name": "C. Verdicchio",
                    //         "ow_person_id": ""
                    //     },
                    //     "attendance": {
                    //         "value": ""
                    //     },
                    //     "coach_team_a": {
                    //         "person": "Gombau",
                    //         "person_id": 233014,
                    //         "ow_person_id": ""
                    //     },
                    //     "coach_team_b": {
                    //         "person": "F. Farina",
                    //         "person_id": 122477,
                    //         "ow_person_id": ""
                    //     }
                    // } 
                    const adaptedGameInfoCoaches = adaptCoachesOnGame(newGameInfoObject, each.data);
                    newGameInfoObject = adaptedGameInfoCoaches;
                    break;
                default:
                // code block
            }
        }
    })

    return newGameInfoObject;
}



function adaptMatchOnGame(stateDataGame, gameDataFromWebsocket) {
    let adaptedStateDataGame = { ...stateDataGame };
    Object.keys(gameDataFromWebsocket).forEach(dataKey => {
        if (["ets_A", "ets_B", "fs_A", "fs_B", "minute", "minute_extra", "ps_A", "ps_B", "winner", "match_period"].includes(dataKey)) {
            adaptedStateDataGame = {
                ...adaptedStateDataGame,
                [dataKey]: gameDataFromWebsocket[dataKey],
            }
        } else if ("status" === dataKey) {
            adaptedStateDataGame = {
                ...adaptedStateDataGame,
                [dataKey]: gameDataFromWebsocket[dataKey],
                statusLive: gameDataFromWebsocket[dataKey],
            }
        }
    })
    return adaptedStateDataGame;
}


function adaptEventsOnGame(stateGameInfo, eventsFromWebsocket) {
    let adaptedStateGameInfo = { ...stateGameInfo };
    if (!adaptedStateGameInfo.hasOwnProperty("events")) {
        adaptedStateGameInfo = {
            ...adaptedStateGameInfo,
            events: []
        }
    }

    Object.keys(eventsFromWebsocket).forEach(eventKey => {
        // try to find event id to updated
        let foundIndex = -1;
        adaptedStateGameInfo.events.forEach((event, index) => {
            if (event.event_id.toString() === eventKey.toString()) {
                foundIndex = index;

                // update values received from websocket into the found event in the array
                Object.keys(eventsFromWebsocket[eventKey]).forEach(key => {
                    adaptedStateGameInfo.events[index] = {
                        ...adaptedStateGameInfo.events[index],
                        [key]: eventsFromWebsocket[eventKey][key],
                    }
                })

            }
        })
        if (foundIndex === -1) {
            adaptedStateGameInfo.events.push(eventsFromWebsocket[eventKey]);
        }


    })
    return adaptedStateGameInfo;
}


function adaptCoachesOnGame(stateGameInfo, coachesFromWebsocket) {
    let adaptedStateGameInfo = { ...stateGameInfo };
    if (coachesFromWebsocket.hasOwnProperty("coach_team_a")) {
        const coachA = coachesFromWebsocket.coach_team_a;

        let foundIndex = -1;
        adaptedStateGameInfo.team_A_coach.forEach((coach, index) => {
            if (coachA.person_id.toString() === coach.person_id.toString()) {
                foundIndex = index;

                // update values received from websocket into the found coach in the array
                adaptedStateGameInfo.team_A_coach[index] = {
                    ...adaptedStateGameInfo.team_A_coach[index],
                    'person_id': coachA.person_id,
                    'person_name': coachA.person
                }
            }
            if (foundIndex === -1) {
                adaptedStateGameInfo.team_A_coach.push(
                    {
                        'person_id': coachA.person_id,
                        'person_name': coachA.person
                    }
                );
            }
        })
    }

    if (coachesFromWebsocket.hasOwnProperty("coach_team_b")) {
        const coachB = coachesFromWebsocket.coach_team_b;

        let foundIndex = -1;
        adaptedStateGameInfo.team_B_coach.forEach((coach, index) => {
            if (coachB.person_id.toString() === coach.person_id.toString()) {
                foundIndex = index;

                // update values received from websocket into the found coach in the array
                adaptedStateGameInfo.team_B_coach[index] = {
                    ...adaptedStateGameInfo.team_B_coach[index],
                    'person_id': coachB.person_id,
                    'person_name': coachB.person
                }
            }
            if (foundIndex === -1) {
                adaptedStateGameInfo.team_B_coach.push(
                    {
                        'person_id': coachB.person_id,
                        'person_name': coachB.person
                    }
                );
            }
        })
    }

    return adaptedStateGameInfo;
}